// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I_DGxqbSjnlwrC {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 32px;
}
@media only screen and (max-width: 750px) {
  .I_DGxqbSjnlwrC {
    justify-content: start;
    max-height: none;
    padding-bottom: 100px;
    overflow-y: scroll;
  }
}
@media screen and (max-height: 800px) {
  .I_DGxqbSjnlwrC {
    justify-content: start;
    overflow-y: scroll;
  }
}
.h5isM99luLWo2p {
  font-size: 24px;
  line-height: 24px;
}
.SENuRWczxXlFPD {
  display: flex;
  position: relative;
  justify-content: center;
  width: 100%;
  min-height: 147px;
  margin-top: 2px;
  overflow: hidden;
}
.WPtq2DM_tJl3_p {
  width: 30%;
  padding-top: 80px;
}
.WnTm8jSsVA0_vw {
  display: flex;
  position: absolute;
  justify-content: center;
  width: 100%;
}
.pPAoHsMXChueLM {
  position: absolute;
  top: -394px;
  width: 958px;
}
.cvxy6nQbM9tzjC {
  position: absolute;
  z-index: 1;
  top: 12px;
  left: 50%;
  transform: translateY(-14px) translateX(-280px);
  opacity: 0;
}
.q0zkkCXs65HQOc {
  margin-left: 32px;
  animation: QG9k6aTKsW75fA 1.33s infinite;
  animation-timing-function: ease;
  animation-direction: alternate;
}
@media (prefers-reduced-motion: reduce) {
  .q0zkkCXs65HQOc {
    animation: none;
  }
}
.wseNqDVXYOr5y5 {
  position: absolute;
  top: 50px;
  left: 161px;
  width: 239px;
  height: 62px;
}
.ZvV4cwvhC4u5vK {
  height: 100%;
}
.kv0eThzbuMjr7b {
  position: absolute;
  top: 12px;
  width: 320px;
  margin-left: -10px;
}
.EKxYbd8fNkMg6W {
  display: flex;
  justify-content: center;
  margin-top: 64px;
  column-gap: 32px;
  transform: scale(0);
}
@media only screen and (max-width: 750px) {
  .EKxYbd8fNkMg6W {
    flex-direction: column;
  }
}
.cSCLlkzm_9c9xc {
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 342px;
  height: 50dvh;
  min-height: 327px;
  overflow: hidden;
  border-radius: 28px;
}
@media only screen and (max-width: 750px) {
  .cSCLlkzm_9c9xc {
    margin-bottom: 30px;
  }
}
.guVAdB_5nUGk7c {
  z-index: 3;
  transform: translate(37%, 10%);
  rotate: -6deg;
}
.qWTgBTulh81ffA {
  z-index: 2;
  transform: translate(-19%, -9%);
  rotate: 2deg;
}
.RvwotiONc24do8 {
  z-index: 1;
  transform: translate(-42%, 4%);
  rotate: 9deg;
}
.guVAdB_5nUGk7c._RYhI7iQbKi9oe {
  transform: translate(0, 0);
  rotate: 0deg;
}
.qWTgBTulh81ffA._RYhI7iQbKi9oe {
  transform: translate(0, 0);
  rotate: 0deg;
}
.RvwotiONc24do8._RYhI7iQbKi9oe {
  transform: translate(0, 0);
  rotate: 0deg;
}
@keyframes mOWwC8xg1pS7rS {
  0% {
    rotate: 0deg;
    transform: translate(100%, 10%);
    opacity: 0;
  }
  50% {
    rotate: -7deg;
    transform: translate(36%, 10%);
    opacity: 1;
  }
  100% {
    rotate: -6deg;
    transform: translate(37%, 10%);
    opacity: 1;
  }
}
@keyframes WSsp2JVYnMnaCV {
  0% {
    rotate: 0deg;
    opacity: 0;
  }
  50% {
    rotate: 2deg;
    opacity: 1;
  }
  100% {
    rotate: 2deg;
    opacity: 1;
  }
}
@keyframes Jc0O2CMRSLfjfl {
  0% {
    rotate: 0deg;
    transform: translate(-100%, 4%);
    opacity: 0;
  }
  50% {
    rotate: 10deg;
    transform: translate(-41%, 4%);
    opacity: 1;
  }
  100% {
    rotate: 9deg;
    transform: translate(-42%, 4%);
    opacity: 1;
  }
}
@keyframes pVBfuK4Pj0Al9X {
  0% {
    transform: translate(37%, 10%);
  }
  50% {
    transform: translate(-1%, 5%);
  }
  100% {
    z-index: 1;
    transform: translate(0, 5%);
  }
}
@keyframes J3ci3hGOIjdscO {
  0% {
    transform: translate(0, 5%);
  }
  50% {
    transform: translate(22%, 0);
  }
  100% {
    transform: translate(21%, 0);
  }
}
@keyframes Z8M6WyPAtgqLG3 {
  0% {
    transform: translate(-19%, -9%);
  }
  50% {
    transform: translate(12%, -11%);
  }
  100% {
    z-index: 3;
    transform: translate(11%, -11%);
  }
}
@keyframes b1cJMO_sJfQiMp {
  0% {
    transform: translate(11%, -11%);
  }
  50% {
    transform: translate(-3.5%, -1.5%);
  }
  100% {
    transform: translate(-3%, -2%);
  }
}
@keyframes s0aikSUNZeaNJp {
  0% {
    transform: translate(-42%, 4%);
  }
  50% {
    transform: translate(-42%, 2%);
  }
  100% {
    transform: translate(-42%, 2%);
  }
}
@keyframes QiSuoxJH6onyq_ {
  0% {
    transform: translate(-42%, 2%);
  }
  50% {
    transform: translate(-42%, -7.5%);
  }
  100% {
    transform: translate(-42%, -7%);
  }
}
@keyframes bM5kZQueS68tRH {
  0% {
    transform: translate(21%, 0);
  }
  50% {
    transform: translate(21%, -0.5%);
  }
  100% {
    transform: translate(21%, -0.5%);
  }
}
@keyframes OroMq_pwlQftQp {
  0% {
    transform: translate(21%, -0.5%);
  }
  50% {
    transform: translate(57%, -9.5%);
  }
  100% {
    transform: translate(56%, -9%);
  }
}
@keyframes mY46NNRepTVMyr {
  0% {
    transform: translate(-3%, -2%);
  }
  50% {
    transform: translate(-29%, -4%);
  }
  100% {
    z-index: 2;
    transform: translate(-28%, -4%);
  }
}
@keyframes yTSLmvOTchwMqi {
  0% {
    transform: translate(-28%, -4%);
  }
  50% {
    transform: translate(5%, -15%);
  }
  100% {
    transform: translate(4%, -14.5%);
  }
}
@keyframes tSV0foD5ZdIK0X {
  0% {
    transform: translate(-42%, -7%);
  }
  50% {
    transform: translate(-7%, -6%);
  }
  100% {
    z-index: 3;
    transform: translate(-8%, -6%);
  }
}
@keyframes calpNeZBiINRyf {
  0% {
    transform: translate(-8%, -6%);
  }
  50% {
    transform: translate(-70%, 7.5%);
  }
  100% {
    transform: translate(-69%, 7%);
  }
}
@keyframes joGhbCBwYhxKyZ {
  0% {
    transform: translate(56%, -9%);
  }
  50% {
    transform: translate(-1%, 0.5%);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes RLd9nTcpDGDp6F {
  0% {
    rotate: -6deg;
  }
  50% {
    rotate: 0.5deg;
  }
  100% {
    rotate: 0deg;
  }
}
@keyframes OSGOuRgBbCkOOm {
  0% {
    transform: translate(4%, -14.5%);
  }
  50% {
    transform: translate(-0.5%, 0.5%);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes XYiT1LKV7wzgNj {
  0% {
    rotate: 2deg;
  }
  50% {
    rotate: -0.25deg;
  }
  100% {
    rotate: 0deg;
  }
}
@keyframes ZlM7nywxh4rTEZ {
  0% {
    transform: translate(-69%, 7%);
  }
  50% {
    transform: translate(1%, -0.5%);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes LTxBZqw5Cb5Xv3 {
  0% {
    rotate: 9deg;
  }
  50% {
    rotate: -1deg;
  }
  100% {
    rotate: 0deg;
  }
}
@keyframes Awu07NRVn886Po {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.02);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes RSN8QoDzfho4Tt {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes YHHGpoJWYeV8ge {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes QG9k6aTKsW75fA {
  0% {
    transform: scale(0.75);
  }
  33% {
    transform: scale(0.75);
  }
  66% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1.25);
  }
}
.EKxYbd8fNkMg6W.cpKU01v8xEWk7z {
  animation: 1s 1s forwards Awu07NRVn886Po;
}
.EKxYbd8fNkMg6W.Z8hKrIhh3QI0n9 {
  transform: scale(1);
}
.guVAdB_5nUGk7c.cpKU01v8xEWk7z {
  animation: 0.7s 0.7s forwards mOWwC8xg1pS7rS;
}
.qWTgBTulh81ffA.cpKU01v8xEWk7z {
  animation: 0.7s 0.7s forwards WSsp2JVYnMnaCV;
}
.RvwotiONc24do8.cpKU01v8xEWk7z {
  animation: 0.7s 0.7s forwards Jc0O2CMRSLfjfl;
}
.guVAdB_5nUGk7c.LwnGI6e6THC9IW {
  animation: 0.7s 0s forwards pVBfuK4Pj0Al9X, 0.7s 1.4s forwards J3ci3hGOIjdscO;
}
.qWTgBTulh81ffA.LwnGI6e6THC9IW {
  animation: 0.7s 0s forwards Z8M6WyPAtgqLG3, 0.7s 1.4s forwards b1cJMO_sJfQiMp;
}
.RvwotiONc24do8.LwnGI6e6THC9IW {
  animation: 0.7s 0s forwards s0aikSUNZeaNJp, 0.7s 1.4s forwards QiSuoxJH6onyq_;
}
.guVAdB_5nUGk7c.gqUkzl7182nRX_ {
  z-index: 1;
  animation: 0.7s 0s forwards bM5kZQueS68tRH, 0.7s 1.4s forwards OroMq_pwlQftQp;
}
.qWTgBTulh81ffA.gqUkzl7182nRX_ {
  animation: 0.7s 0s forwards mY46NNRepTVMyr, 0.7s 1.4s forwards yTSLmvOTchwMqi;
}
.RvwotiONc24do8.gqUkzl7182nRX_ {
  animation: 0.7s 0s forwards tSV0foD5ZdIK0X, 0.7s 1.4s forwards calpNeZBiINRyf;
}
.guVAdB_5nUGk7c.UCI9zNmR_dmsVj {
  z-index: 1;
  animation: 0.7s 0s forwards joGhbCBwYhxKyZ, 0.7s 0.35s forwards RLd9nTcpDGDp6F;
}
.qWTgBTulh81ffA.UCI9zNmR_dmsVj {
  z-index: 2;
  animation: 0.7s 0s forwards OSGOuRgBbCkOOm, 0.7s 0.35s forwards XYiT1LKV7wzgNj;
}
.RvwotiONc24do8.UCI9zNmR_dmsVj {
  z-index: 3;
  animation: 0.7s 0s forwards ZlM7nywxh4rTEZ, 0.7s 0.35s forwards LTxBZqw5Cb5Xv3;
}
.mdETazXe62eg1i {
  animation: 1s 0s forwards RSN8QoDzfho4Tt;
}
.W3yuBRm6NzJxMy {
  opacity: 1;
}
.piLexWuTVLKeKc {
  opacity: 1;
}
.fUhMAjBNuHqusN {
  animation: 1s 0s forwards YHHGpoJWYeV8ge;
}
.QjNvG0Tr7Olr32 {
  opacity: 0;
}
@keyframes ZAn47SYK8ujDJs {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.f0qAZdkBxFpLfW {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: #00000029;
}
._JrrulzqSafL1Y {
  width: 0;
  height: 6px;
  animation: 8s linear 0s forwards ZAn47SYK8ujDJs;
  border-radius: 3px;
  background-color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselScreen": `I_DGxqbSjnlwrC`,
	"carouselScreenHeading": `h5isM99luLWo2p`,
	"progressIndicatorAndNavWrapper": `SENuRWczxXlFPD`,
	"progressIndicator": `WPtq2DM_tJl3_p`,
	"island": `WnTm8jSsVA0_vw`,
	"lottie": `pPAoHsMXChueLM`,
	"islandDecorators": `cvxy6nQbM9tzjC`,
	"arrow": `q0zkkCXs65HQOc`,
	"resizeAnimation": `QG9k6aTKsW75fA`,
	"navigateToInboxPulse": `wseNqDVXYOr5y5`,
	"navigateToInboxButton": `ZvV4cwvhC4u5vK`,
	"gesturalLines": `kv0eThzbuMjr7b`,
	"animatingCards": `EKxYbd8fNkMg6W`,
	"animatingCard": `cSCLlkzm_9c9xc`,
	"inboxCard": `guVAdB_5nUGk7c`,
	"plannerCard": `qWTgBTulh81ffA`,
	"boardCard": `RvwotiONc24do8`,
	"endStep": `_RYhI7iQbKi9oe`,
	"firstStep": `cpKU01v8xEWk7z`,
	"firstStepAllTogether": `Awu07NRVn886Po`,
	"afterFirstStep": `Z8hKrIhh3QI0n9`,
	"inboxFirstStep": `mOWwC8xg1pS7rS`,
	"plannerFirstStep": `WSsp2JVYnMnaCV`,
	"boardFirstStep": `Jc0O2CMRSLfjfl`,
	"secondStep": `LwnGI6e6THC9IW`,
	"inboxSecondStepPart1": `pVBfuK4Pj0Al9X`,
	"inboxSecondStepPart2": `J3ci3hGOIjdscO`,
	"plannerSecondStepPart1": `Z8M6WyPAtgqLG3`,
	"plannerSecondStepPart2": `b1cJMO_sJfQiMp`,
	"boardSecondStepPart1": `s0aikSUNZeaNJp`,
	"boardSecondStepPart2": `QiSuoxJH6onyq_`,
	"thirdStep": `gqUkzl7182nRX_`,
	"inboxThirdStepPart1": `bM5kZQueS68tRH`,
	"inboxThirdStepPart2": `OroMq_pwlQftQp`,
	"plannerThirdStepPart1": `mY46NNRepTVMyr`,
	"plannerThirdStepPart2": `yTSLmvOTchwMqi`,
	"boardThirdStepPart1": `tSV0foD5ZdIK0X`,
	"boardThirdStepPart2": `calpNeZBiINRyf`,
	"fourthStep": `UCI9zNmR_dmsVj`,
	"inboxFourthStepPart1": `joGhbCBwYhxKyZ`,
	"inboxFourthStepPart2": `RLd9nTcpDGDp6F`,
	"plannerFourthStepPart1": `OSGOuRgBbCkOOm`,
	"plannerFourthStepPart2": `XYiT1LKV7wzgNj`,
	"boardFourthStepPart1": `ZlM7nywxh4rTEZ`,
	"boardFourthStepPart2": `LTxBZqw5Cb5Xv3`,
	"elementFadeIn": `mdETazXe62eg1i`,
	"fadeIn": `RSN8QoDzfho4Tt`,
	"elementFadeInFinal": `W3yuBRm6NzJxMy`,
	"elementFadeOutInitial": `piLexWuTVLKeKc`,
	"elementFadeOut": `fUhMAjBNuHqusN`,
	"fadeOut": `YHHGpoJWYeV8ge`,
	"elementFadeOutFinal": `QjNvG0Tr7Olr32`,
	"progressIndicatorBackground": `f0qAZdkBxFpLfW`,
	"progressIndicatorValue": `_JrrulzqSafL1Y`,
	"progressIndicatorAnimation": `ZAn47SYK8ujDJs`
};
export default ___CSS_LOADER_EXPORT___;
